import './ad_slider';
import '../external/lazysizes.min.js';
import { adReview } from './ad_review';
import './ad_slider_datalayer';
import { reviewImageSlider } from './review_image_slider';

$(function () {
    let $body = $('body');

    // image slider on review images
    reviewImageSlider.init();

    // Redirect to listing page on changing Model dropdown
    $body.on('change', '#brandModel', function () {
        let make = $('#brandData').data('seo-make');
        let model = $(this).val();
        if (model) {
            location.href = Routing.generate('ad_listing', { arg1: make, arg2: model });
        }
        return false;
    });

    // save user's like/dis-like on review comment
    $body.on('click', '.saveReviewLike', function () {
        adReview.saveUserOpinionOnReviewComment($(this));
    });

    // Read more/less review comment
    $body.on('click', '.readMoreReviewComment', function () {
        adReview.showHideComment($(this).data('review-id'));
    });
});
